export default __webpack_public_path__ + "static/media/companies_icon_black.20e5f98b.svg";